import { Tab } from "@headlessui/react";
import { ReactNode } from "react";
import { twMerge } from "tailwind-merge";

const InlineTabRoot = ({
  children,
  className,
  onClick,
}: {
  children: ReactNode;
  className?: string;
  onClick?: () => void;
}) => {
  return (
    <Tab
      onClick={onClick}
      className={({ selected }) =>
        twMerge(
          "flex h-[50px] h-full cursor-pointer items-center justify-center px-4 py-2 transition-colors hover:bg-gray-100",
          selected ? "bg-gray-100" : "bg-white",
          className,
        )
      }
    >
      {children}
    </Tab>
  );
};

const List = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => {
  return (
    <Tab.List
      className={twMerge(
        "flex w-fit divide-x divide-slate-200 overflow-auto rounded-lg border border-solid border-slate-200 p-0 font-bold",
        className,
      )}
    >
      {children}
    </Tab.List>
  );
};

export const InlineTabGroup = Tab.Group;
export const InlineTabPanels = Tab.Panels;
export const InlineTabPanel = Tab.Panel;
export { InlineTabRoot as InlineTab, List as InlineTabList };
